// store/slices/reportPeriodSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { getCurrentMonth, getStartOfYear } from '../../Utils/FormatDate';

/* ---------- helpers ---------- */
const saveDate = (key, date) => {
  if (date instanceof Date && !isNaN(date)) {
    localStorage.setItem(key, date.toISOString());
  }
};

/* readBoolean returns defaultValue if the key is missing */
const readBoolean = (key, defaultValue) => {
  const stored = localStorage.getItem(key);
  return stored === null ? defaultValue : JSON.parse(stored);
};

const parseStoredDate = (key, fallback) => {
  const stored = localStorage.getItem(key);
  const parsed = stored ? new Date(stored) : fallback;
  return isNaN(parsed) ? fallback : parsed;
};
/* -------------------------------- */

const initialStartDate     = parseStoredDate('StartDate',     getStartOfYear(new Date()));
const initialEndDate       = parseStoredDate('EndDate',       getCurrentMonth(new Date()));
const initialStartYearDate = new Date(Date.UTC(initialStartDate.getFullYear(), 0 , 1));
const initialEndYearDate   = new Date(Date.UTC(initialEndDate.getFullYear()  , 11, 31));
const initialIsMonthly     = readBoolean('isMonthly', true);          // <── NEW

const initialState = {
  isMonthly     : initialIsMonthly,                                   // <──
  startDate     : initialStartDate,
  endDate       : initialEndDate,
  startYearDate : initialStartYearDate,
  endYearDate   : initialEndYearDate,
};

const reportPeriodSlice = createSlice({
  name        : 'reportPeriodSlice',
  initialState,
  reducers    : {
    /** Pass any subset of the fields, e.g. { startDate, endDate } */
    setRange(state, { payload }) {
      Object.assign(state, payload);

      if (payload.startDate)     saveDate('StartDate',     payload.startDate);
      if (payload.endDate)       saveDate('EndDate',       payload.endDate);
      if (payload.startYearDate) saveDate('StartYearDate', payload.startYearDate);
      if (payload.endYearDate)   saveDate('EndYearDate',   payload.endYearDate);

      /*  store both true *and* false  */
      if ('isMonthly' in payload) {
        localStorage.setItem('isMonthly', JSON.stringify(payload.isMonthly));
      }
    },
    reset: () => initialState,
  },
});

export const { setRange, reset } = reportPeriodSlice.actions;
export default reportPeriodSlice.reducer;
